define("shared/utils/uuid", ["exports"], function (_exports) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _default;
  0; //eaimeta@70e063a35619d71feaimeta@70e063a35619d71f
  /**
   * @module Utils
   */

  /**
   * @class UuidUtil
   * @extends Utils
   */

  /**
   * Creates a universally unique identifier (UUID) to be used
   * for creating unique refrences to objects without worrying
   * about key collisions
   *
   * @method uuid
   *
   * @returns {String}
   */
  function _default() {
    function s4() {
      return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
    }
    return s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
  }
});